export function AmbientBackground() {
  return (
    <div className="site-ambient" aria-hidden="true">
      <div className="site-ambient__parallax">
        <div className="site-ambient__glow" />
        <div className="site-ambient__orb site-ambient__orb--a" />
        <div className="site-ambient__orb site-ambient__orb--b" />
        <div className="site-ambient__orb site-ambient__orb--c" />
        <div className="site-ambient__orb site-ambient__orb--d" />
        <div className="site-ambient__orb site-ambient__orb--e" />
        <div className="site-ambient__orb site-ambient__orb--f" />
        <div className="site-ambient__orb site-ambient__orb--g" />
        <div className="site-ambient__orb site-ambient__orb--h" />
        <div className="site-ambient__shimmer" />
        <div className="site-ambient__grain" />
      </div>
      <div className="site-ambient__vignette" />
    </div>
  );
}
